import React, { useEffect, useState } from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { DEMO_URL } from '../../data/dgpt';
import { CtaButton } from '../ui/CtaButton';
import { cn } from '../../src/lib/utils';

/** Tasteful bottom CTA on small screens, revealed after the hero scrolls away. */
export function MobileStickyCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > window.innerHeight * 0.6);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <div className={cn('fixed inset-x-0 bottom-0 z-30 border-t border-hairline bg-ink/90 px-4 pb-[calc(env(safe-area-inset-bottom)+12px)] pt-3 backdrop-blur-xl transition-[transform,visibility] duration-300 sm:hidden', visible ? 'visible translate-y-0' : 'invisible translate-y-full')} data-id="element-252" data-mp="25rt8gbbbd0s">
      <CtaButton href={DEMO_URL} event="mobile_sticky_book_demo_click" size="lg" className="w-full" data-id="element-253" data-mp="21eymypi8sp13">
        Book a Demo
        <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-254" data-mp="18916fou24bi0" />
      </CtaButton>
    </div>;
}